import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M20.8993 5.00257H3.10073V5C2.80895 5.00067 2.52945 5.11994 2.32313 5.3318C2.1168 5.54368 2.00065 5.83069 2 6.13028V15.8697C2.00066 16.1693 2.1168 16.4563 2.32313 16.6682C2.52946 16.8801 2.80897 16.9993 3.10073 17H20.8993C21.1911 16.9993 21.4706 16.8801 21.6769 16.6682C21.8832 16.4563 21.9993 16.1693 22 15.8697V6.13286C21.9993 5.83325 21.8832 5.54607 21.6769 5.33421C21.4705 5.12251 21.191 5.00308 20.8993 5.00257ZM21.4391 20C22.848 20 24 19.0999 24 18H0C0 19.0998 1.15213 20 2.56089 20H21.4391Z"
    fillRule="evenodd"
  />,
  'Laptop',
)
